export const dadosIniciais = {
  id: 0,
  cpf: '',
  cns: '',
  nome: '',
  nomeSocial: '',
  email: '',
  nomeDaMae: '',
  raca: '',
  sexo: '',
  dataNascimento: '',
  identidadeDeGenero: '',
  estadoCivil: '',
  naturalidade: 23,
  religiao: '',
  lateralidade: '',
  escolaridade: '',
  profissao: '',
  estadoNascimento: '',
  municipioNascimento: '',
  tipoDeTrabalho: '',
  ultimasAtividades: '',
  condicaoAtual: '',
  quantoTempo: '',
  enderecoCep: '',
  enderecoCodigoUf: '',
  enderecoIBGE: '',
  enderecoLogradouro: '',
  enderecoBairro: '',
  enderecoNumero: '',
  enderecoComplemento: '',
  numeroTelefone: [1],
  responsavelTelefone: [],
  dadosDeContato: [{ telefone: "", nome: "" }],
  senha: '',
}